import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ToastService } from 'src/app/services/toast.service';
import { UtilsService } from 'src/app/services/utils.service';
import { Announcement, AnnouncementCategory, ExaminingBoard, Institute, Job } from 'src/models';
import { EnumAnnouncementType } from 'src/models/enums';

@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./../public.component.css', './announcements.component.css']
})
export class AnnouncementsComponent implements OnInit, AfterViewInit {
  //Variáveis
  isNavCollapsed = true; //Flag Indicando Navbar Collapsada em Celulares

  pageLoading = false; //Flag Relacionada ao Carregamento da Página
  pageError = false; //Flag Relacionada com o Erro da Página

  announcementFilter: { dates: Array<any>, regions: Array<any>, states: Array<any>, objectives: Array<any>, boards: Array<any>, institutes: Array<any>, years: Array<any>, categories: Array<any>, keyword: string } = { dates: [], regions: [], states: [], objectives: [], boards: [], institutes: [], years: [], categories: [], keyword: '' };
  listExaminingBoards: Array<ExaminingBoard> = []; //Lista com Todas as Bancas
  listInstitutes: Array<Institute> = []; //Lista com Todas as Instituições
  displayInstitutes = 'Instituições'; //Instituições Selecionadas
  displayCategories = 'Categorias'; //Categorias Selecionadas

  filters: { //Filtro
    types?: Array<string>,
    page?: number,
    perPage?: number,
    categoryIds?: Array<number>,
    instituteIds?: Array<number>,
    states?: Array<string>,
    ids?: Array<number>,
    includeJobs?: boolean,
    orderBys?: string,
    word?: Array<string>
  } = {};
  reqTimeout: any = null; //Timeout de Requisição dos Editais Via Pesquisa
  collapseFilter = true; //Ocultar-Exibir Filtros Avançados
  announcementsPage = 20; //Quantidade de Editais por Requisição
  currentPage = 1; //Página de Editais da Requisição

  listAnnouncements: Array<Array<Announcement>> = []; //Lista com o Editais de Busca

  listInterests: Array<AnnouncementCategory> = []; //Lista de Interesses

  mapInstituteImages: Map<number, string> = new Map(); //Mapa Relacionando Id da Instituição com a URL da Imagem

  constructor(
    private _utilsService: UtilsService,
    private _toastService: ToastService,
    private _title: Title
  ) { }

  ngOnInit(): void {
    this._title.setTitle('Estudei | Editais Disponíveis');

    this.pageLoading = true;
  }

  ngAfterViewInit(): void {
    this.currentPage = 1;

    this.listAnnouncements = [];
    this.GetAnnouncements();
    this.CreateFilters();
  }

  //Manipular Scroll ao Atingir o Final da Lista
  onScroll() {
    this.currentPage += 1;

    this.GetAnnouncements();
  }

  //Obter Editais
  GetAnnouncements() {
    //Adaptar Editais nos Filtros
    this.ParserFilter();

    this._utilsService.getPublicAnnouncements(this.currentPage, this.announcementsPage, this.filters).subscribe(
      announcements => {
        this.listAnnouncements.push(announcements.filter(ann => ann.active));

        let selectedInstitutes = new Set();
        this.listAnnouncements.forEach(an => {
          an.forEach(a => {
            //Obter Imagens das Instituições
            if (!this.mapInstituteImages.get(a.instituteId))
              this.GetInstituteImage(a.instituteId);

            //Filtrar Lista de Instituições
            selectedInstitutes.add(a.instituteId);
          });
        });

        this.pageLoading = false;
      },
      error => {
        this._toastService.error('Edital', `Ocorreu um erro ao obter a lista de editais`);
      }
    );
  }

  //Adaptar Editais nos Filtros
  ParserFilter() {
    const types = this.announcementFilter.objectives.filter(o => o.show).map(o => o.value);
    this.filters.types = types.length ? types : undefined;

    const categories = this.announcementFilter.categories.filter(c => c.show).map(c => c.id);
    this.filters.categoryIds = categories.length ? categories : undefined;

    const institutes = this.announcementFilter.institutes.filter(i => i.show).map(i => i.id);
    this.filters.instituteIds = institutes.length ? institutes : undefined;

    const states = this.announcementFilter.states.filter(s => s.show).map(s => s.name);
    this.filters.states = states.length ? states : undefined;

    const keywords = this.announcementFilter.keyword.split(' ');
    this.filters.word = keywords.length ? keywords : undefined;

    this.filters.orderBys = 'popularity';
    this.filters.includeJobs = true;
  }

  //Obter Imagem da Instituição
  GetInstituteImage(instituteId: number) {
    this.mapInstituteImages.set(instituteId, '#');

    this._utilsService.getServerImage(`/public/institutes/${instituteId}/image`).subscribe(
      image => {
        this.mapInstituteImages.set(instituteId, URL.createObjectURL(image));
      }
    );
  }

  //Procurar Editais
  SearchAnnouncements(search?: any | null) {
    if (this.reqTimeout) { clearTimeout(this.reqTimeout); }

    this.reqTimeout = setTimeout(() => {
      this.announcementFilter.keyword = search || '';
      this.currentPage = 1;
      this.listAnnouncements = [];

      this.GetAnnouncements();
    }, 1000);

    //Exibir Instituições e Categorias Selecionadas
    let selectedInstitutes = '', selectedCategories = '';
    this.announcementFilter.institutes.forEach(institute => {
      if (institute.show) selectedInstitutes += `${institute.name}, `;
    });
    this.announcementFilter.categories.forEach(category => {
      if (category.show) selectedCategories += `${category.name}, `;
    });
    selectedInstitutes = selectedInstitutes.slice(0, -2);
    selectedCategories = selectedCategories.slice(0, -2);
    this.displayInstitutes = selectedInstitutes || 'Instituições';
    this.displayCategories = selectedCategories || 'Categorias';
  }

  //Atualizar Filtros dos Editais
  UpdateFilters(type: 'region', aux: string, show: boolean) {
    switch (type) {
      case 'region':
        if (aux == 'Norte') {
          const states = this.announcementFilter.states.filter(s => s.name == 'AC' || s.name == 'AM' || s.name == 'AP' || s.name == 'PA' || s.name == 'RO' || s.name == 'RR' || s.name == 'TO');
          states.forEach(state => { state.show = show });
        } else if (aux == 'Nordeste') {
          const states = this.announcementFilter.states.filter(s => s.name == 'AL' || s.name == 'BA' || s.name == 'CE' || s.name == 'MA' || s.name == 'PB' || s.name == 'PE' || s.name == 'PI' || s.name == 'RN' || s.name == 'SE');
          states.forEach(state => { state.show = show });
        } else if (aux == 'Centro-Oeste') {
          const states = this.announcementFilter.states.filter(s => s.name == 'DF' || s.name == 'GO' || s.name == 'MS' || s.name == 'MT');
          states.forEach(state => { state.show = show });
        } else if (aux == 'Sul') {
          const states = this.announcementFilter.states.filter(s => s.name == 'PR' || s.name == 'RS' || s.name == 'SC');
          states.forEach(state => { state.show = show });
        } else if (aux == 'Sudeste') {
          const states = this.announcementFilter.states.filter(s => s.name == 'ES' || s.name == 'MG' || s.name == 'RJ' || s.name == 'SP');
          states.forEach(state => { state.show = show });
        } else if (aux == 'Federal') {
          const federal = this.announcementFilter.states.find(s => s.name == 'FEDERAL');
          federal.show = show;
        }
        break;
    }
  }

  //Obter Requisições Auxiliares ao Filtro
  GetAuxFilters(req: 'institute' | 'category') {
    switch (req) {
      case 'institute':
        if (this.listInstitutes.length) break;
        this.announcementFilter.institutes.push({ id: -1, name: 'Carregando...', show: false });
        this._utilsService.getPublicInstitutes().subscribe(
          next => {
            this.listInstitutes = next;
            this.announcementFilter.institutes = [];
            next.forEach(institute => {
              this.announcementFilter.institutes.push({ id: institute.id, name: institute.name, show: false });
            });

            //Filtrar Lista de Instituições com Editais Listados
            // let selectedInstitutes = new Set();
            // this.listAnnouncements.forEach(a => { selectedInstitutes.add(a.instituteId); });
            // this.announcementFilter.institutes = [];
            // this.listInstitutes.filter(i => selectedInstitutes.has(i.id)).forEach(institute => {
            //   this.announcementFilter.institutes.push({ id: institute.id, name: institute.name, show: false });
            // });
          },
          error => {
            this._toastService.warning('Intituição', 'Ocorreu um erro ao obter a lista de instituições');
          }
        );
        break;

      case 'category':
        if (this.listInterests.length) break;
        this.announcementFilter.categories.push({ id: -1, name: 'Carregando...', show: false });
        this._utilsService.getPublicAnnouncementCategories().subscribe(
          categories => {
            this.listInterests = categories;
            this.announcementFilter.categories = [];

            //Manipular o "Outros"
            const others = categories.find(i => i.name == 'Outros' || i.name == 'Outras');
            if (others) {
              const index = categories.indexOf(others);
              categories.splice(index, 1);
              categories.push(others);
            }

            categories.forEach(category => {
              this.announcementFilter.categories.push({ id: category.id, name: category.name, show: false });
            });
          },
          error => {
            this.listInterests.push(new AnnouncementCategory({ id: 1, name: EnumAnnouncementType.ConcursoPublico }));
            this._toastService.warning('Categoria', 'Ocorreu um erro ao obter a lista de categorias');
          }
        );
        break;
    }
  }

  //Criar Filtros dos Editais
  CreateFilters() {
    //Datas
    this.announcementFilter.dates.push({ name: 'Em Destaque', show: false });
    this.announcementFilter.dates.push({ name: 'Previstos', show: false });
    this.announcementFilter.dates.push({ name: 'Abertos', show: false });
    this.announcementFilter.dates.push({ name: 'Encerrados', show: false });

    //Regiões
    this.announcementFilter.regions.push({ name: 'Norte', show: false });
    this.announcementFilter.regions.push({ name: 'Nordeste', show: false });
    this.announcementFilter.regions.push({ name: 'Centro-Oeste', show: false });
    this.announcementFilter.regions.push({ name: 'Sul', show: false });
    this.announcementFilter.regions.push({ name: 'Sudeste', show: false });
    this.announcementFilter.regions.push({ name: 'Federal', show: false });

    //Estados
    const listStates = [
      'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO',
      'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
      'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO', 'FEDERAL'
    ];
    for (let s = 0; s < listStates.length; s++) {
      this.announcementFilter.states.push({ name: listStates[s], show: false });
    }

    //Objetivos
    for (let type of Object.values(EnumAnnouncementType)) {
      this.announcementFilter.objectives.push({ value: type, show: false });
    }

    //Anos
    const actualYear = (new Date()).getFullYear();
    for (let y = 0; y < 10; y++) {
      this.announcementFilter.years.push({ name: (actualYear - y), show: false });
    }
  }

}
